// @ts-nocheck
import { Box, Typography, Divider } from '@mui/material';
import { Check } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import './SecondRoundSuccessfulMessage.css';

/**
 * A functional React component for rendering a custom successful message for
 * submitting passenger information for the second round.
 *
 * @param {string} id - The ID for the component.
 * @param {object} data - The data object containing the trip information.
 * @param {...object} rest - Additional props to be spread on the parent element.
 *
 * @returns {JSX.Element} React element representing the successful message.
 */
const SecondRoundSuccessfulMessage = ({ id, data, ...rest }) => {
  const { t } = useTranslation(['trip', 'common', 'bookings']);
  const tripTitle = data?.trip?.tripname || '';

  return (
    <Box
      className='second-round_successfull-message'
      id={id}
      data-testid='payment-transaction-successful'
      {...rest}
    >
      <Box className='second-round_successfull-message__content'>
        <Box className='second-round_successfull-message__header'>
          <span className={`second-round_successfull-message__outer-circle`}>
            <Check size={32} fill={'#ffffff'} />
          </span>
        </Box>

        <Typography
          variant='body1'
          className='second-round_successfull-message__main-message'
        >
          {t(
            'bookings:formSubmittedSuccessful',
            'Passenger information submitted successfully!'
          )}
        </Typography>

        <Typography
          className={`second-round_successfull-message__confirmation-email text-center `}
        >
          {tripTitle}
        </Typography>
        <Divider className='second-round_successfull-message__divider' />
        <Typography
          variant='body2'
          className='second-round_successfull-message__persistent-link text-center'
          sx={{ fontStyle: 'italic', color: 'text.secondary', mt: 1 }}
        >
          {t(
            'bookings:persistentLinkNote',
            'You can return to this link at any time to update your information.'
          )}
        </Typography>
      </Box>
    </Box>
  );
};

SecondRoundSuccessfulMessage.propTypes = {
  id: PropTypes.string.isRequired
};

export default SecondRoundSuccessfulMessage;
